export enum UserError {
  userExists = 'USER_EXISTS',
}

export enum EventError {
  isInThePast = 'EVENT_IS_IN_THE_PAST',
  dateOverlap = 'EVENT_DATE_OVERLAP',
  noAvailableSubscriptionEventsInMonth = 'NO_AVAILABLE_SUBSCRIPTION_EVENTS_IN_MONTH',
  notSavedWouldCollide = 'NOT_SAVED_WOULD_COLLIDE',
}
